import React from 'react';
import { NotificationManager } from 'react-notifications';

export default function ClickCopyComponent({ children, text }) {
    const onClick = () => {
        navigator.clipboard.writeText(text);
        NotificationManager.info(`Copied`);
    };
    return <span onClick={onClick}>{children}</span>
}